import axios, { AxiosResponse } from "axios";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { ApiSearchResponse } from "../models/common";
import { IExpensePeriod } from "../models/expenseType";

export const addExpensePeriod = async (
    expensePeriod: IExpensePeriod,
): Promise<AxiosResponse<IExpensePeriod>> => {
    return await axios.post("/dispatcher/expensePeriod", expensePeriod);
};

export const changeExpensePeriod = async (
    expensePeriod: IExpensePeriod,
): Promise<AxiosResponse<IExpensePeriod>> => {
    return await axios.patch("/dispatcher/expensePeriod", expensePeriod);
};

export const deleteExpensePeriod = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/dispatcher/expensePeriod/${id}`);
};

export const getExpensePeriod = async (id: string): Promise<AxiosResponse<IExpensePeriod>> => {
    return await axios.get(`/dispatcher/expensePeriod/${id}`);
};

export const searchExpensePeriod = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IExpensePeriod> => {
    return await axios.post("/dispatcher/expensePeriod/search", searchParams);
};
